/**
 * Merge Alpine mixins into a component without killing their computed properties.
 *
 * Object spread copies a getter's *value*, not the getter: `{...mixin()}`
 * evaluates every `get foo()` once, against a mixin that has no component data
 * yet, and freezes whatever it said then. A `get guarantees()` reading an empty
 * store becomes a permanent `[]`, and nothing on screen can ever react to it.
 *
 * Copying property descriptors keeps getters as getters. Arguments are applied
 * in order, so pass the mixins first and the component's own members last: the
 * component then wins any name it shares with a mixin, exactly as spread did.
 */
export function withMixins(...objects) {
  return objects.reduce((merged, object) => {
    if (!object) return merged

    return Object.defineProperties(merged, Object.getOwnPropertyDescriptors(object))
  }, {})
}
